/**
 * MudMixer Mega Menu — Multi-handle support
 * Each trigger button [data-mm-mega-trigger="handle"] pairs with
 * a panel [data-mm-mega-panel="handle"]. Panel is positioned below
 * the trigger (not full-width).
 */
(function () {
  'use strict';

  var HOVER_DELAY = 100;

  function initDesktopMega() {
    var triggers = document.querySelectorAll('[data-mm-mega-trigger]');
    var overlay = document.querySelector('[data-mm-mega-overlay]');
    if (!triggers.length) return;

    var activeTrigger = null;
    var activePanel = null;
    var hoverTimeout = null;
    var closeTimeout = null;

    function getPanel(handle) {
      return document.querySelector('[data-mm-mega-panel="' + handle + '"]');
    }

    function positionPanel(trigger, panel) {
      var headerSection = document.querySelector('.section-header');
      if (!headerSection) return;

      var headerRect = headerSection.getBoundingClientRect();

      /* Fixed position, top aligned to bottom of header */
      panel.style.position = 'fixed';
      panel.style.top = headerRect.bottom + 'px';

      /* Center panel horizontally on the viewport */
      var panelWidth = panel.offsetWidth || 600;
      var left = (window.innerWidth - panelWidth) / 2;
      left = Math.max(16, left);
      panel.style.left = left + 'px';
    }

    function open(trigger) {
      var handle = trigger.getAttribute('data-mm-mega-trigger');
      var panel = getPanel(handle);
      if (!panel) return;

      clearTimeout(closeTimeout);

      /* Close any other open panel first */
      if (activePanel && activePanel !== panel) {
        closeImmediate();
      }

      activeTrigger = trigger;
      activePanel = panel;

      positionPanel(trigger, panel);
      panel.classList.add('is-active');
      if (overlay) overlay.classList.add('is-active');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closeImmediate() {
      // Keep inline position styles in place so the panel fades out where it
      // opened. They get re-applied on the next open() via positionPanel().
      if (activePanel) activePanel.classList.remove('is-active');
      if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');
      if (overlay) overlay.classList.remove('is-active');
      activeTrigger = null;
      activePanel = null;
    }

    function close() {
      clearTimeout(hoverTimeout);
      if (!activePanel) return;
      closeImmediate();
    }

    function scheduleOpen(trigger) {
      clearTimeout(closeTimeout);
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(function () { open(trigger); }, HOVER_DELAY);
    }

    function scheduleClose() {
      clearTimeout(hoverTimeout);
      closeTimeout = setTimeout(close, HOVER_DELAY);
    }

    /* Bind events per trigger */
    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () { scheduleOpen(trigger); });
      trigger.addEventListener('mouseleave', scheduleClose);

      /* Keyboard focus opens the panel so keyboard users get parity with hover.
         Click/Enter on the <a> falls through to navigate to link.url. */
      trigger.addEventListener('focus', function () { scheduleOpen(trigger); });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && activeTrigger === trigger) {
          close();
          trigger.focus();
        }
      });
    });

    /* Keep panel open on hover */
    document.querySelectorAll('[data-mm-mega-panel]').forEach(function (panel) {
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimeout); });
      panel.addEventListener('mouseleave', scheduleClose);

      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          close();
          if (activeTrigger) activeTrigger.focus();
          return;
        }
        if (e.key === 'Tab') {
          var focusable = panel.querySelectorAll('a[href], button:not([disabled])');
          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      });
    });

    /* Close on click outside trigger and panel */
    document.addEventListener('mousedown', function (e) {
      if (!activePanel) return;
      if (!e.target.closest('[data-mm-mega-trigger]') && !e.target.closest('[data-mm-mega-panel]')) {
        close();
      }
    });

    /* Reposition on scroll/resize */
    var rafId = null;
    function reposition() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        if (activeTrigger && activePanel) positionPanel(activeTrigger, activePanel);
        rafId = null;
      });
    }
    window.addEventListener('scroll', reposition, { passive: true });
    window.addEventListener('resize', reposition, { passive: true });

    /* Close when Dawn hides header */
    var sectionHeader = document.querySelector('.section-header');
    if (sectionHeader) {
      new MutationObserver(function () {
        if (sectionHeader.classList.contains('shopify-section-header-hidden')) close();
      }).observe(sectionHeader, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ── Mobile accordion ───────────────────────────────────── */
  function initMobileAccordion() {
    document.querySelectorAll('[data-mm-drawer-group]').forEach(function (group) {
      var btn = group.querySelector('[data-mm-drawer-group-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = group.classList.contains('is-open');
        group.parentElement.querySelectorAll('[data-mm-drawer-group]').forEach(function (g) {
          g.classList.remove('is-open');
          var b = g.querySelector('[data-mm-drawer-group-btn]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          group.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function init() {
    initDesktopMega();
    initMobileAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('[data-mm-mega-panel]')) init();
    });
  }
})();
